/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleTurnChatLanguageEnum } from './SingleTurnChatLanguageEnum';
import {
  SingleTurnChatLanguageEnumFromJSON,
  SingleTurnChatLanguageEnumFromJSONTyped,
  SingleTurnChatLanguageEnumToJSON,
} from './SingleTurnChatLanguageEnum';
import type { SingleTurnChatGenerationKnowledgeBase } from './SingleTurnChatGenerationKnowledgeBase';
import {
  SingleTurnChatGenerationKnowledgeBaseFromJSON,
  SingleTurnChatGenerationKnowledgeBaseFromJSONTyped,
  SingleTurnChatGenerationKnowledgeBaseToJSON,
} from './SingleTurnChatGenerationKnowledgeBase';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';

/**
 *
 * @export
 * @interface GenerationInputsPolymorphicSingleTurnChatGenerationInputs
 */
export interface GenerationInputsPolymorphicSingleTurnChatGenerationInputs {
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof GenerationInputsPolymorphicSingleTurnChatGenerationInputs
   */
  taskType: TaskTypeEnum;
  /**
   *
   * @type {number}
   * @memberof GenerationInputsPolymorphicSingleTurnChatGenerationInputs
   */
  readonly id: number;
  /**
   *
   * @type {SingleTurnChatGenerationKnowledgeBase}
   * @memberof GenerationInputsPolymorphicSingleTurnChatGenerationInputs
   */
  knowledgeBase: SingleTurnChatGenerationKnowledgeBase;
  /**
   *
   * @type {string}
   * @memberof GenerationInputsPolymorphicSingleTurnChatGenerationInputs
   */
  description?: string;
  /**
   *
   * @type {SingleTurnChatLanguageEnum}
   * @memberof GenerationInputsPolymorphicSingleTurnChatGenerationInputs
   */
  language?: SingleTurnChatLanguageEnum;
  /**
   *
   * @type {any}
   * @memberof GenerationInputsPolymorphicSingleTurnChatGenerationInputs
   */
  examples?: any | null;
  /**
   *
   * @type {string}
   * @memberof GenerationInputsPolymorphicSingleTurnChatGenerationInputs
   */
  styleGuide?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof GenerationInputsPolymorphicSingleTurnChatGenerationInputs
   */
  autoNSamples?: boolean;
  /**
   *
   * @type {number}
   * @memberof GenerationInputsPolymorphicSingleTurnChatGenerationInputs
   */
  nSamples?: number | null;
  /**
   *
   * @type {number}
   * @memberof GenerationInputsPolymorphicSingleTurnChatGenerationInputs
   */
  maxSamples?: number | null;
}

/**
 * Check if a given object implements the GenerationInputsPolymorphicSingleTurnChatGenerationInputs interface.
 */
export function instanceOfGenerationInputsPolymorphicSingleTurnChatGenerationInputs(
  value: object,
): value is GenerationInputsPolymorphicSingleTurnChatGenerationInputs {
  if (!('taskType' in value) || value['taskType'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('knowledgeBase' in value) || value['knowledgeBase'] === undefined) return false;
  return true;
}

export function GenerationInputsPolymorphicSingleTurnChatGenerationInputsFromJSON(
  json: any,
): GenerationInputsPolymorphicSingleTurnChatGenerationInputs {
  return GenerationInputsPolymorphicSingleTurnChatGenerationInputsFromJSONTyped(json, false);
}

export function GenerationInputsPolymorphicSingleTurnChatGenerationInputsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GenerationInputsPolymorphicSingleTurnChatGenerationInputs {
  if (json == null) {
    return json;
  }
  return {
    taskType: TaskTypeEnumFromJSON(json['task_type']),
    id: json['id'],
    knowledgeBase: SingleTurnChatGenerationKnowledgeBaseFromJSON(json['knowledge_base']),
    description: json['description'] == null ? undefined : json['description'],
    language: json['language'] == null ? undefined : SingleTurnChatLanguageEnumFromJSON(json['language']),
    examples: json['examples'] == null ? undefined : json['examples'],
    styleGuide: json['style_guide'] == null ? undefined : json['style_guide'],
    autoNSamples: json['auto_n_samples'] == null ? undefined : json['auto_n_samples'],
    nSamples: json['n_samples'] == null ? undefined : json['n_samples'],
    maxSamples: json['max_samples'] == null ? undefined : json['max_samples'],
  };
}

export function GenerationInputsPolymorphicSingleTurnChatGenerationInputsToJSON(
  value?: Omit<GenerationInputsPolymorphicSingleTurnChatGenerationInputs, 'id'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    task_type: TaskTypeEnumToJSON(value['taskType']),
    knowledge_base: SingleTurnChatGenerationKnowledgeBaseToJSON(value['knowledgeBase']),
    description: value['description'],
    language: SingleTurnChatLanguageEnumToJSON(value['language']),
    examples: value['examples'],
    style_guide: value['styleGuide'],
    auto_n_samples: value['autoNSamples'],
    n_samples: value['nSamples'],
    max_samples: value['maxSamples'],
  };
}
